// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m91wug{overflow-y:auto}\n._1bsbauwl{width:100vw}\n._1reo1wug{overflow-x:auto}\n._4t3i1kxc{height:100vh}", ""]);
// Exports
module.exports = exports;
